import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Droplets, Leaf } from "lucide-react";

const oilGasServices = [
  { name: "Fluidos de perforación", path: "/oil-gas/drilling-fluids" },
  { name: "Fluidos de completamiento", path: "/oil-gas/completion-fluids" },
  { name: "Control de sólidos", path: "/oil-gas/solid-control" },
  { name: "Consultoría y optimización", path: "/oil-gas/consulting" },
  { name: "Productos químicos", path: "/oil-gas/chemical-products" },
];

const ambientalServices = [
  { name: "Monitoreo ambiental", path: "/environmental/monitoring" },
  { name: "Análisis de laboratorio", path: "/environmental/laboratory" },
  { name: "Consultoría ambiental", path: "/environmental/consultancy" },
  { name: "Descarbonización", path: "/environmental/decarbonization" },
  { name: "Alquiler de equipos", path: "/environmental/equipment" },
];

const ArrowIcon = () => (
  <ArrowRight
    size={18}
    className="
      text-gray-400
      transition-all duration-300
      group-hover:stroke-[#ee7d32]
      group-hover:translate-x-1
    "
  />
);

const ServiceList = ({ title, icon, services }) => (
  <div className="space-y-5">

    {/* HEADER */}
    <div className="flex items-center gap-3">
      <div className="p-2 rounded-lg bg-gray-100 text-[#ee7d32]">
        {icon}
      </div>

      <h2 className="text-2xl font-semibold text-gray-800">
        {title}
      </h2>
    </div>

    {/* LISTA */}
    <div className="border rounded-xl overflow-hidden bg-white">
      {services.map((service, index) => (
        <Link
          key={index}
          to={service.path}
          className="
            group flex items-center justify-between
            px-5 py-4
            border-b last:border-b-0
            hover:bg-gray-50
            transition-colors duration-200
          "
        >
          <span
            className="
              text-gray-700
              group-hover:text-[#ee7d32]
              transition-colors
            "
          >
            {service.name}
          </span>

          <ArrowIcon />
        </Link>
      ))}
    </div>
  </div>
);

export default function Services() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">

        <div className="mb-10">
          <h1 className="text-3xl font-bold text-gray-900">
            Nuestros Servicios
          </h1>
          <p className="text-gray-500 mt-1">
            Soluciones técnicas para Oil & Gas y ambiental
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10">

          <ServiceList
            title="Oil & Gas"
            icon={<Droplets size={20} />}
            services={oilGasServices}
          />

          <ServiceList
            title="Ambiental"
            icon={<Leaf size={20} />}
            services={ambientalServices}
          />

        </div>
      </div>
    </section>
  );
}